import api from '../../../api';

export type NodeHierarchy = {
  displayPrefix: boolean;
  id: string;
  prefix?: string;
  title: string;
};

export type ExerciseSession = {
  resumable: boolean;
  result?: {
    amountOfItems: number;
    duration: number;
    score: {
      maximum: number;
      achievable: number;
      achieved: number;
    };
    session: string;
  };
};

type ExerciseAssignmentSession = {
  resumable: boolean;
  restartable: boolean;
  isExpired: boolean;
  session?: string;
  result?: {
    amountOfItems: number;
    duration: number;
    score: {
      maximum: number;
      achievable: number;
      achieved: number;
    };
  };
};

export async function getExerciseAssignmentSession(
  moduleId: string,
  assignmentId: string,
): Promise<ExerciseAssignmentSession> {
  const { data } = await api.get<ExerciseAssignmentSession>(
    `/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session`,
  );

  return data;
}
